export default __webpack_public_path__ + "static/media/O-064.a281adc7.png";